import { ReactNode } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { FieldPath } from "react-hook-form/dist/types";
import { Checkbox, FormControlLabel } from "@mui/material";

const FilterCheckbox = <T extends FieldValues>(props: {
  name: FieldPath<T>;
  facetKey: unknown;
  label: ReactNode;
  control?: Control<T>;
}) => (
  <FormControlLabel
    sx={{ mr: 0, "& p": { lineHeight: 1.2 } }}
    value={props.facetKey}
    control={
      <Controller
        control={props.control}
        name={props.name}
        render={({ field }) => (
          <Checkbox
            sx={{ ml: 0.5, mr: 0.5, p: 0.5, borderRadius: "4px" }}
            size="small"
            checked={field.value.includes(props.facetKey)}
            {...field}
            value={props.facetKey}
            onChange={(e) => {
              if (e.target.checked) {
                field.onChange([...field.value, e.target.value]);
              } else {
                field.onChange(field.value.filter((val: string) => val !== e.target.value));
              }
            }}
          />
        )}
      />
    }
    label={props.label}
  />
);

export default FilterCheckbox;
